if (!customElements.get('coffee-product-details')) {
  customElements.define(
    'coffee-product-details',
    class CoffeeProductDetails extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
      }

      select(selectedTab) {
        this.tabs.forEach((tab) => {
          const selected = tab === selectedTab;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
        });
      }
    }
  );
}
